import { omitBy } from "lodash";
import { ApiMessageLogsListParams, ApiMessageLogsReportBody } from "../log-analyser.models";

export const mapFilterParamsToDownloadVoiceReportPayload = (qp: Partial<ApiMessageLogsListParams>, timezone: string, notifyByMail: boolean = false): any  => {
    return {
        startDate: qp.startDate,
        endDate: qp.endDate,
        accountId: qp.accountId,
        ...omitBy({
            campaignId: qp.campaignId,
            campaignStatus: qp.campaignStatus,
            senderName: qp.senderName,
            eventStatus: "", // TODO: Business inconsitent, no way to set this value from to view
            messageStatus: "", // TODO: no way to set up this value in views
            status: qp.customerStatus,
            messageType: qp.messageType,
            recipient: qp.recipient,
            channels: qp.channels,
            product: qp.products,
            senderNumber: qp.senderNumber,
            notifyByMail,
            customerReason: qp.customerReason,
            caller: qp.caller,
            direction: qp.direction,
        },(v) => v === null || v === undefined || v === '')

    }
}